<template>
  <div class="ibox">
    <div class="ibox-title"><h5>自动择日</h5></div>
    <div class="ibox-content">
    <div class="crud-bar">
      <el-date-picker v-model="date" type="date" value-format="yyyy-MM-dd" placeholder="筛选日期" @change="fetch" />
      <el-button icon="el-icon-refresh" @click="fetch">刷新</el-button>
      <el-button type="primary" icon="el-icon-plus" @click="openCreate('')">新增用事</el-button>
      <span class="tip">日期无需预先存在于 dateriqis，保存时后端按日期自动归属。</span>
    </div>

    <el-collapse v-loading="loading" v-model="activeNames">
      <el-collapse-item
        v-for="d in list"
        :key="d.id"
        :name="d.id"
        :title="`${isoDate(d.date)}（${(d.yongshis || []).length} 个用事）`"
      >
        <div class="group-bar">
          <el-button size="mini" type="primary" plain icon="el-icon-plus" @click="openCreate(isoDate(d.date))">在此日期新增用事</el-button>
        </div>
        <el-table :data="d.yongshis || []" border size="small">
          <el-table-column prop="yongshi" label="用事" min-width="180" show-overflow-tooltip />
          <el-table-column prop="start_time" label="开始" width="160" />
          <el-table-column prop="end_time" label="结束" width="160" />
          <el-table-column label="优劣" width="80">
            <template slot-scope="s">
              <el-tag :type="s.row.youzhi === '1' ? 'success' : 'info'" size="mini">
                {{ s.row.youzhi === '1' ? '优质' : '普通' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="命度/天顶" width="150">
            <template slot-scope="s">{{ mdText(s.row) }}</template>
          </el-table-column>
          <el-table-column label="前后" width="95">
            <template slot-scope="s">{{ qianhouText(s.row) }}</template>
          </el-table-column>
          <el-table-column prop="extra_one" label="备注" min-width="140" show-overflow-tooltip />
          <el-table-column label="操作" width="140">
            <template slot-scope="s">
              <el-button size="mini" @click="openEdit(d, s.row)">编辑</el-button>
              <el-button size="mini" type="danger" @click="onDelete(s.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-collapse-item>
    </el-collapse>
    <div v-if="!loading && !list.length" class="empty">暂无择日数据</div>

    <el-dialog
      :title="form.id ? '编辑用事' : '新增用事'"
      :visible.sync="dialogVisible"
      width="760px"
      :close-on-click-modal="false"
    >
      <el-form label-width="110px" size="small">
        <el-row :gutter="12">
          <el-col :span="8">
            <el-form-item label="日期" required>
              <el-date-picker v-model="form.date" type="date" value-format="yyyy-MM-dd" placeholder="选择日期" style="width:100%" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="开始时间" required>
              <el-date-picker v-model="form.start_time" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="开始时间" style="width:100%" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="结束时间" required>
              <el-date-picker v-model="form.end_time" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="结束时间" style="width:100%" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="用事">
          <el-select v-model="yongshiArr" multiple filterable allow-create default-first-option placeholder="选择或输入用事" style="width:100%">
            <el-option-group v-for="c in classifyList" :key="c.value" :label="c.value">
              <el-option v-for="o in c.children" :key="o.value" :value="o.value" :label="o.label" />
            </el-option-group>
          </el-select>
        </el-form-item>

        <el-form-item label="用事等级">
          <div v-if="!yongshiArr.length" class="tip">先选择「用事」，再为相关分类设置优质 / 普通。</div>
          <div v-else class="grade-list">
            <div v-for="c in relevantCategories" :key="c.index" class="grade-row">
              <span class="grade-cat">{{ c.value }}</span>
              <el-radio-group v-model="formyouzhiMap[c.index]">
                <el-radio label="1">优质</el-radio>
                <el-radio label="2">普通</el-radio>
                <el-radio label="0">不涉及</el-radio>
              </el-radio-group>
            </div>
          </div>
        </el-form-item>

        <el-row :gutter="12">
          <el-col :span="8">
            <el-form-item label="时间前后">
              <el-radio-group v-model="form.qianhou">
                <el-radio label="之前">之前</el-radio>
                <el-radio label="之后">之后</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="分数">
              <el-input-number v-model="form.fenshu" :min="0" :step="1" controls-position="right" style="width:100%" />
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="命度/天顶">
              <el-radio-group v-model="form.md_type">
                <el-radio label="1">命度</el-radio>
                <el-radio label="2">天顶</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item :label="form.md_type === '2' ? '天顶' : '命度'">
          <div class="md-row">
            <el-select v-model="mingdu.gong" placeholder="宫" style="width:88px">
              <el-option v-for="(g, i) in gongList" :key="g" :value="i" :label="g" />
            </el-select>
            <span class="md-unit">宫</span>
            <el-input-number v-model="mingdu.du" :min="0" :max="29" controls-position="right" style="width:100px" />
            <span class="md-unit">度</span>
            <el-input-number v-model="mingdu.fen" :min="0" :max="59" controls-position="right" style="width:100px" />
            <span class="md-unit">分</span>
            <el-input-number v-model="mingdu.miao" :min="0" :max="59" controls-position="right" style="width:100px" />
            <span class="md-unit">秒</span>
          </div>
        </el-form-item>

        <el-row :gutter="12">
          <el-col :span="12">
            <el-form-item label="福主本命">
              <el-select v-model="fuzhuArr" multiple placeholder="选择宫位" style="width:100%">
                <el-option v-for="g in gongList" :key="g" :value="g" :label="g" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="座山">
              <el-select v-model="zuoshanArr" multiple filterable allow-create default-first-option placeholder="选择或输入座山" style="width:100%">
                <el-option v-for="z in zuoshanList" :key="z" :value="z" :label="z" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="日课备注">
          <el-input v-model="form.extra_one" type="textarea" :rows="2" maxlength="200" show-word-limit placeholder="备注（extra_one）" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="onSubmit">保存</el-button>
      </div>
    </el-dialog>
    </div>
  </div>
</template>

<script>
// 用事分类与座山候选表复用用户端 autoSelect 的同一份常量：
// 分类顺序即语义 —— 后端 YongshiCategories.CLASSIFY 与 formyouzhi 的下标一一对应，
// 这里若另抄一份，后续调序就会导致优质/普通判定整体错位。
import { classifyList } from '@t/pages/autoSelect/classifyList'
import { zuoshanList } from '@t/pages/autoSelect/zuoshanList'
import { dateriqiApi } from '../api/business'

const GONG_LIST = ['子', '丑', '寅', '卯', '辰', '巳', '午', '未', '申', '酉', '戌', '亥']
const CATEGORY_COUNT = classifyList.length

// 优质度取值：语义由「读方」决定，别被后端变量名（good/normal）带偏 ——
//   DateSelectionController#getAutoDate 把 formyouzhi 分段 '1' 收进 list2、'2' 收进 list；
//   而 dateSelection/index.vue 里 res.list2 → youList（优质日课）、res.list → heList（合适日课）。
// 于是：'1'=优质、'2'=普通（合适）、'0'=不涉及，与用户端 autoSelect 的 radio 文案一致。
// youzhi 是 formyouzhi 为空时的兜底等级，同一套取值。
function splitTilde (value) {
  return value ? String(value).split('~').filter(s => s !== '') : []
}

// Vue 2 无法侦测数组下标赋值，故 formyouzhi / mingdu 一律用「预先建好键的对象」承载，
// 否则 v-model="arr[i]" 改了值但视图不重渲染（单选、下拉看起来没反应）。
function buildFormyouzhiMap (segments) {
  const arr = segments.slice(0, CATEGORY_COUNT)
  while (arr.length < CATEGORY_COUNT) arr.push('0')
  const map = {}
  for (let i = 0; i < CATEGORY_COUNT; i++) map[i] = arr[i] || '0'
  return map
}

function buildMingdu (mdData) {
  const parts = splitTilde(mdData)
  const pick = (i) => {
    const n = parseInt(parts[i], 10)
    return Number.isNaN(n) ? 0 : n
  }
  return { gong: pick(0), du: pick(1), fen: pick(2), miao: pick(3) }
}

function emptyMingdu () {
  return { gong: 0, du: 0, fen: 0, miao: 0 }
}

// dateriqis 列表由后端手工组装 Map（row.put("date", LocalDate)），没走 Yongshi.date 上的
// @JsonFormat；实测本地返回的是 "2026-12-01"，但保留 Jackson 时间戳数组形态的兜底归一化。
function isoDate (value) {
  if (value === null || value === undefined) return ''
  if (Array.isArray(value)) {
    const y = value[0]; const m = value[1]; const d = value[2]
    if (y === undefined) return ''
    return `${y}-${String(m).padStart(2, '0')}-${String(d).padStart(2, '0')}`
  }
  return String(value).slice(0, 10)
}

function emptyForm () {
  return {
    id: null,
    date: '',
    start_time: '',
    end_time: '',
    qianhou: '之后',
    fenshu: 0,
    md_type: '1',
    extra_one: ''
  }
}

export default {
  name: 'AdminAutoDates',
  data () {
    return {
      loading: false,
      saving: false,
      date: '',
      list: [],
      activeNames: [],
      dialogVisible: false,
      classifyList,
      zuoshanList,
      gongList: GONG_LIST,
      form: emptyForm(),
      yongshiArr: [],
      fuzhuArr: [],
      zuoshanArr: [],
      formyouzhiMap: buildFormyouzhiMap([]),
      mingdu: emptyMingdu()
    }
  },
  computed: {
    // 需要设置等级的用事分类：包含已选用事的分类，外加本就有非 '0' 取值的分类（编辑历史数据时可见）
    relevantCategories () {
      return classifyList
        .map((c, index) => ({ value: c.value, index, children: c.children }))
        .filter(c => c.children.some(o => this.yongshiArr.indexOf(o.value) >= 0) ||
          (this.formyouzhiMap[c.index] && this.formyouzhiMap[c.index] !== '0'))
    }
  },
  created () {
    this.fetch()
  },
  methods: {
    // 供模板使用（模板只能访问实例成员）
    isoDate,
    async fetch () {
      this.loading = true
      try {
        this.list = await dateriqiApi.list(this.date)
        this.activeNames = this.list.slice(0, 3).map(d => d.id)
      } catch (e) {
        this.$message.error(e.uiMessage || e.message)
      } finally {
        this.loading = false
      }
    },
    mdText (row) {
      const label = row.md_type === '2' ? '天顶' : '命度'
      const parts = splitTilde(row.md_data)
      if (!parts.length) return `${label} —`
      const gongIndex = parseInt(parts[0], 10)
      const gong = Number.isNaN(gongIndex) ? parts[0] : (GONG_LIST[gongIndex] || parts[0])
      return `${label} ${gong}${parts[1] || 0}°${parts[2] || 0}′${parts[3] || 0}″`
    },
    qianhouText (row) {
      const fen = row.fenshu === null || row.fenshu === undefined ? '' : `${row.fenshu}分`
      return `${row.qianhou || ''}${fen}`
    },
    formyouzhiString () {
      const out = []
      for (let i = 0; i < CATEGORY_COUNT; i++) out.push(this.formyouzhiMap[i] || '0')
      return out.join('~')
    },
    // youzhi 是 formyouzhi 为空时的兜底等级：任一分段为优质即记优质
    deriveYouzhi () {
      for (let i = 0; i < CATEGORY_COUNT; i++) {
        if (this.formyouzhiMap[i] === '1') return '1'
      }
      return '2'
    },
    openCreate (date) {
      this.form = emptyForm()
      this.form.date = date || this.date || ''
      this.yongshiArr = []
      this.fuzhuArr = []
      this.zuoshanArr = []
      this.formyouzhiMap = buildFormyouzhiMap([])
      this.mingdu = emptyMingdu()
      this.dialogVisible = true
    },
    openEdit (group, row) {
      this.form = {
        id: row.id,
        date: isoDate(row.date || group.date),
        start_time: row.start_time || '',
        end_time: row.end_time || '',
        qianhou: row.qianhou || '之后',
        fenshu: row.fenshu === null || row.fenshu === undefined ? 0 : Number(row.fenshu),
        md_type: row.md_type || '1',
        extra_one: row.extra_one || ''
      }
      this.yongshiArr = splitTilde(row.yongshi)
      this.fuzhuArr = splitTilde(row.fuzhuming)
      this.zuoshanArr = splitTilde(row.zuoshan)
      this.formyouzhiMap = buildFormyouzhiMap(splitTilde(row.formyouzhi))
      this.mingdu = buildMingdu(row.md_data)
      this.dialogVisible = true
    },
    async onSubmit () {
      if (!this.form.date) return this.$message.warning('请选择日期')
      if (!this.form.start_time || !this.form.end_time) return this.$message.warning('请选择开始 / 结束时间')

      const payload = {
        id: this.form.id,
        date: this.form.date,
        start_time: this.form.start_time,
        end_time: this.form.end_time,
        qianhou: this.form.qianhou,
        fenshu: this.form.fenshu,
        md_type: this.form.md_type,
        md_data: [this.mingdu.gong, this.mingdu.du, this.mingdu.fen, this.mingdu.miao].join('~'),
        extra_one: this.form.extra_one,
        yongshi: this.yongshiArr.join('~'),
        fuzhuming: this.fuzhuArr.join('~'),
        zuoshan: this.zuoshanArr.join('~'),
        formyouzhi: this.formyouzhiString(),
        youzhi: this.deriveYouzhi()
      }
      if (!payload.id) delete payload.id

      this.saving = true
      try {
        await dateriqiApi.saveYongshi(payload)
        this.$message.success('保存成功')
        this.dialogVisible = false
        await this.fetch()
        // 新增的日期可能不在原列表里，把对应分组展开方便核对（collapse 的 name 是 dateriqi.id）
        const saved = this.list.find(d => isoDate(d.date) === payload.date)
        if (saved) this.activeNames = [saved.id]
      } catch (e) {
        this.$message.error(e.uiMessage || e.message)
      } finally {
        this.saving = false
      }
    },
    async onDelete (row) {
      if (!await this.$confirm('确认删除该用事？', '提示', { type: 'warning' }).catch(() => false)) return
      try {
        await dateriqiApi.deleteYongshi(row.id)
        this.$message.success('已删除')
        this.fetch()
      } catch (e) {
        this.$message.error(e.uiMessage || e.message)
      }
    }
  }
}
</script>

<style scoped>
.crud-bar { margin-bottom: 16px; display: flex; align-items: center; gap: 12px; }
.tip { color: #909399; font-size: 13px; }
.group-bar { margin-bottom: 10px; }
.empty { text-align: center; color: #909399; padding: 40px; }
.grade-list { border: 1px solid #ebeef5; border-radius: 4px; padding: 8px 12px; }
.grade-row { display: flex; align-items: center; padding: 2px 0; }
.grade-cat { width: 150px; color: #606266; }
.md-row { display: flex; align-items: center; gap: 6px; }
.md-unit { color: #909399; margin-right: 10px; }
</style>
